module.exports = __webpack_public_path__ + "static/media/moac.7edd6826.svg";